import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {NotificationModalComponent} from './notification-modal/notification-modal.component';
import {SettingsPassOnLogComponent} from './settings-pass-on-log.component';
import {SettingsPassOnLogDetailedViewComponent} from './settings-pass-on-log-detailed-view/settings-pass-on-log-detailed-view.component';
import {SettingsPassOnLogService} from '../../services/settings-pass-on-log.service';
import {SettingsPassOnLogListComponent} from './settings-pass-on-log-list/settings-pass-on-log-list.component';
import {UtilsModule} from '../../modules/utils/utils.module';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        UtilsModule
    ],
    declarations: [
        SettingsPassOnLogComponent,
        SettingsPassOnLogDetailedViewComponent,
        NotificationModalComponent,
        SettingsPassOnLogListComponent
    ],
    providers: [
        SettingsPassOnLogService
    ]
})
export class SettingsPassOnLogModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/settings-pass-on-log/settings-pass-on-log.module.ts